const translations = {
  // Geral
  newProcess: 'Novo',
  home: 'Início',
  login: 'Entrar',
  register: 'Cadastrar',
  logout: 'Sair',
  error: 'Erro',
  success: 'Sucesso',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  processing: 'Processando...',
  loading: 'Carregando...',
  sending: 'Enviando...',
  save: 'Salvar',
  delete: 'Excluir',
  back: 'Voltar',
  allRightsReserved: 'Todos os direitos reservados',
  
  // Autenticação
  email: 'E-mail',
  password: 'Senha',
  name: 'Nome',
  signUp: 'Cadastrar',
  alreadyHaveAccount: 'Já tem uma conta? Entre',
  needAccount: 'Precisa de uma conta? Cadastre-se',
  forgotPassword: 'Esqueceu a senha?',
  resetPassword: 'Recuperar Senha',
  sendResetLink: 'Enviar Link de Recuperação',
  backToLogin: 'Voltar para Login',
  resetPasswordEmailSent: 'E-mail de Recuperação Enviado',
  checkYourEmail: 'Verifique sua caixa de entrada para o link de recuperação',
  signUpSuccess: 'Cadastro Realizado com Sucesso',
  passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
  passwordRequirements: 'A senha deve conter minúscula, maiúscula, número e símbolo',
  passwordPlaceholder: 'Mín 8 chars: Aa1@...',
  nameRequired: 'O nome é obrigatório',
  nameTooShort: 'Nome deve ter pelo menos 2 caracteres',
  invalidEmail: 'Formato de e-mail inválido',
  rememberMe: 'Lembrar-me',
  emailAlreadyInUse: 'Este e-mail já está em uso. Por favor, faça login ou use outro e-mail.',
  pwReqMinLength: 'Pelo menos 8 caracteres',
  pwReqLowercase: 'Uma letra minúscula',
  pwReqUppercase: 'Uma letra maiúscula',
  pwReqNumber: 'Um número',
  pwReqSymbol: 'Um caractere especial (!@#$...)',
  emailConfirmationTitle: 'Verifique seu E-mail',
  emailConfirmationDescription: 'Enviamos um link de confirmação para o seu e-mail. Por favor, acesse sua caixa de entrada e clique no link para ativar sua conta.',
  emailConfirmationNote: 'Não recebeu o e-mail? Verifique sua pasta de spam ou lixo eletrônico.',
  understood: 'Entendi',
  resendEmail: 'Reenviar e-mail',
  resendEmailSuccess: 'E-mail reenviado com sucesso!',
  resendIn: 'Reenviar em {{seconds}}s',
  resetPasswordDescription: 'Enviamos um link de recuperação para o seu e-mail. Por favor, acesse sua caixa de entrada e clique no link para redefinir sua senha.',
  resetPasswordNote: 'Não recebeu o e-mail? Verifique sua pasta de spam ou lixo eletrônico.',
  goToLogin: 'Ir para Login',
  createNewPassword: 'Criar Nova Senha',
  createNewPasswordDesc: 'Digite sua nova senha abaixo.',
  newPassword: 'Nova Senha',
  confirmPassword: 'Confirmar Senha',
  passwordsDontMatch: 'As senhas não coincidem',
  passwordsMatch: 'As senhas coincidem',
  passwordResetSuccess: 'Senha Redefinida com Sucesso',
  passwordResetSuccessDesc: 'Sua senha foi alterada. Você será redirecionado para o login.',
  linkExpiredTitle: 'Link Expirado',
  linkExpiredDescription: 'Este link de recuperação é inválido ou expirou. Por favor, solicite um novo link.',
  requestNewLink: 'Solicitar Novo Link',
  saveNewPassword: 'Salvar Nova Senha',

  // Conta de usuário
  myAccount: 'Minha Conta',
  userMenu: 'Menu do Usuário',
  unnamed: 'Sem nome',
  deleteAccount: 'Excluir Conta',
  deleteAccountConfirm: 'Confirmar Exclusão da Conta',
  deleteAccountWarning: 'Tem certeza de que deseja excluir sua conta?',
  deleteAccountConsequences: 'Esta ação é irreversível e resultará em perda permanente de dados.',
  finalDeleteConfirm: 'Confirmação Final de Exclusão',
  finalDeleteWarning: 'Esta é sua última chance! Excluir sua conta irá:',
  deleteAccountEffect1: 'Remover todos os seus dados de nossos sistemas.',
  deleteAccountEffect2: 'Cancelar todas as assinaturas ativas.',
  deleteAccountEffect3: 'Desconectá-lo permanentemente.',
  deleteAccountFinal: 'Sim, Excluir Minha Conta',
  accountDeleted: 'Sua conta foi excluída com sucesso.',
  
  // Assinatura
  subscriptionPage: 'Assinatura',
  availablePlans: 'Planos Disponíveis',
  yourSubscription: 'Sua Assinatura',
  subscriptionStatus: 'Status da Assinatura',
  subscriptionDetails: 'Detalhes da Assinatura',
  plan: 'Plano',
  planLabel: 'Plano',
  priceLabel: 'Preço',
  currentPeriod: 'Período Atual',
  status: 'Status',
  endsAt: 'Termina em',
  cancelSubscription: 'Cancelar Assinatura',
  subscribe: 'Assinar',
  manageSubscription: 'Gerenciar Assinatura',
  billingHistory: 'Histórico de Faturamento',
  updatePaymentMethod: 'Atualizar Método de Pagamento',
  paymentMethod: 'Método de Pagamento',
  cardNumber: 'Número do Cartão',
  expirationDate: 'Data de Validade',
  cvc: 'CVC',
  update: 'Atualizar',
  saveChanges: 'Salvar Alterações',
  errorFetchingSubscription: 'Falha ao buscar dados da assinatura. Por favor, tente novamente mais tarde.',
  subscriptionCanceled: 'Assinatura Cancelada',
  subscriptionResumed: 'Assinatura Reativada',
  loadingSubscription: 'Carregando dados da assinatura...',
  noActiveSubscription: 'Sem Assinatura Ativa',
  noActiveSubscriptionDescription: 'Você não tem uma assinatura ativa. Por favor, selecione um plano para assinar.',
  viewAvailablePlans: 'Ver Planos Disponíveis',
  
  // Planos
  freePlan: 'Plano Gratuito',
  basicPlan: 'Plano Básico',
  advancedPlan: 'Plano Avançado',
  unlimitedPlan: 'Plano Ilimitado',
  freePlanDescription: 'Para uso ocasional e testes',
  basicPlanDescription: 'Para usuários individuais',
  advancedPlanDescription: 'Para usuários profissionais',
  unlimitedPlanDescription: 'Para uso intensivo',
  labelsPerDay: 'etiquetas/dia',
  unlimitedLabels: 'Conversões ilimitadas',
  freeFeature2: 'Suporte padrão',
  freeFeature3: 'Processamento manual de etiquetas',
  basicFeature2: 'Suporte por e-mail',
  basicFeature3: 'Processamento em lote',
  advancedFeature2: 'Suporte prioritário',
  advancedFeature3: 'Processamento em lote',
  advancedFeature4: 'Histórico por 90 dias',
  unlimitedFeature2: 'Suporte premium',
  unlimitedFeature3: 'Processamento avançado em lote',
  unlimitedFeature4: 'Histórico ilimitado',
  month: 'mês',
  popularTag: 'Popular',
  freePlanButton: 'Começar Grátis',
  selectPlan: 'Selecionar Plano',
  freePlanSelected: 'Plano Gratuito Selecionado',
  freePlanSelectedDescription: 'Você está usando o plano gratuito com recursos limitados.',
  simplePricing: 'Preços Simples e Transparentes',
  errorProcessingRequest: 'Erro ao processar sua solicitação. Por favor, tente novamente.',
  loginRequired: 'Você precisa estar logado para assinar.',
  
  // Subscrição Success
  subscriptionSuccess: 'Assinatura Bem-sucedida',
  subscriptionSuccessMessage: 'Sua assinatura foi concluída com sucesso.',
  subscriptionThankYou: 'Obrigado pela sua assinatura. Você agora tem acesso a todos os recursos do plano selecionado.',
  viewSubscription: 'Ver Sua Assinatura',
  
  // Navegação
  accessApplication: 'Acessar Aplicativo',
  goToDashboard: 'Ir para o Dashboard',
  
  // Upload e Processamento
  dragAndDrop: 'Arraste e solte seus arquivos aqui',
  acceptedFormats: 'Formatos aceitos: .txt, .zpl ou .zip com arquivos ZPL',
  selectFile: 'Selecionar Arquivo',
  dropHere: 'Solte os arquivos aqui',
  processingZip: 'Processando arquivo ZIP',
  fileUploaded: 'Arquivo Enviado',
  fileProcessed: 'O arquivo {{fileName}} foi processado',
  zipProcessed: 'ZIP Processado',
  zipFilesExtracted: '{{count}} arquivos ZPL extraídos',
  noZplFilesInZip: 'Nenhum arquivo ZPL encontrado no arquivo ZIP',
  noValidZplContent: 'Nenhum conteúdo ZPL válido encontrado no arquivo',
  zipProcessingError: 'Erro ao processar o arquivo ZIP',
  readError: 'Erro de Leitura',
  readErrorMessage: 'Erro ao ler o arquivo',
  
  // Histórico
  date: 'Data',
  dateShort: 'Data',
  labelCount: 'Quantidade de Etiquetas',
  labelsShort: 'Qtd',
  typeShort: 'Tipo',
  timeShort: 'Tempo',
  view: 'Visualizar',
  download: 'Baixar',
  viewPdf: 'Visualizar PDF',
  close: 'Fechar',
  downloadUnavailableAfterRefresh: 'Download indisponível após atualizar a página',
  deleteRecordConfirm: 'Excluir Registro',
  deleteRecordWarning: 'Tem certeza de que deseja excluir este registro? Esta ação não pode ser desfeita.',
  
  // Dashboard
  title: 'ZPL Easy',
  subtitle: 'Carregue seus arquivos ZPL para convertê-los para o formato PDF',
  processingHistory: 'Histórico de Processamento',
  loadingHistory: 'Carregando histórico...',
  noHistory: 'Nenhum histórico de processamento encontrado',
  totalRecords: 'Total: {{count}} registros',
  downloadStarted: 'Download Iniciado',
  downloadStartedDesc: 'O download do seu arquivo foi iniciado',
  
  // Preview & Conversion
  totalLabels: 'Total de Etiquetas',
  labelsProcessed: '{{count}} etiquetas processadas',
  downloadAgain: 'Baixar Novamente',
  printDirect: 'Imprimir',
  process: 'Processar',
  converting: 'Convertendo...',
  successMessage: 'Conversão concluída com sucesso',
  errorMessage: 'Erro ao processar o arquivo',
  mergePdfError: 'Erro ao mesclar arquivos PDF',
  
  // Feedback
  feedback: 'Feedback',
  sendFeedback: 'Enviar Feedback',
  feedbackType: 'Tipo de feedback',
  selectFeedbackType: 'Selecione o tipo de feedback',
  feedbackMessage: 'Mensagem',
  feedbackMessagePlaceholder: 'Descreva seu feedback detalhadamente...',
  feedbackSuggestion: 'Sugestão',
  feedbackBug: 'Erro',
  feedbackComplaint: 'Reclamação',
  feedbackOther: 'Outro',
  requiredFields: 'Campos obrigatórios',
  fillAllFields: 'Por favor, preencha todos os campos.',
  feedbackSent: 'Feedback enviado!',
  feedbackThankYou: 'Obrigado pelo seu feedback. Entraremos em contato em breve.',
  errorSendingFeedback: 'Erro ao enviar feedback',
  tryAgainLater: 'Tente novamente mais tarde ou entre em contato diretamente.',
  sendFeedbackButton: 'Enviar Feedback',
  
  // Formato de impressão
  printFormat: 'Formato de Impressão',
  standardFormat: 'Padrão',
  hdFormat: 'Nitidez+',
  selectPrintFormat: 'Selecione como deseja imprimir suas etiquetas',
  formatDescription: 'Escolha o formato que melhor se adapta à sua impressora',
  hdFormatDescription: 'Nitidez maximizada com IA',
  standardFormatDescription: 'Etiquetas individuais em sequência',
  hdFormatWarning: 'Atenção: Nitidez+ é mais lento',
  hdFormatWarningMessage: 'O modo Nitidez+ utiliza IA para maximizar a nitidez de cada etiqueta. Este processo pode levar mais tempo que o modo padrão.',
  
  // Pagination
  previous: 'Anterior',
  next: 'Próximo',
  
  // Multiple file upload
  dragAndDropMultiple: 'Arraste e solte seus arquivos aqui (múltiplos arquivos suportados)',
  selectFiles: 'Selecionar Arquivos',
  selectMoreFiles: 'Selecionar Mais Arquivos',
  filesSelected: '{{count}} arquivos selecionados',
  processingFiles: 'Processando arquivos...',
  filesProcessed: 'Arquivos Processados',
  multipleFilesExtracted: '{{fileCount}} arquivos processados, {{labelCount}} etiquetas extraídas',
  errorProcessingFiles: 'Erro ao processar um ou mais arquivos',
  
  // File Tray
  fileTray: 'Arquivos Selecionados',
  viewDetails: 'Ver detalhes',
  hideDetails: 'Ocultar',
  file: 'arquivo',
  files: 'arquivos',
  label: 'etiqueta',
  labels: 'etiquetas',
  clearAll: 'Limpar tudo',
  clearAllConfirm: 'Limpar todos os arquivos?',
  clearAllConfirmMessage: 'Isso removerá {{count}} arquivo(s) selecionado(s). Esta ação não pode ser desfeita.',
  addMoreFiles: 'Adicionar mais',
  readyToProcess: 'Pronto',
  removeFile: 'Remover arquivo',
  
  // Process Again
  processAgain: 'Reprocessar',
  
  // Beta Notice
  betaNotice: '🚧 Esta ferramenta está em fase BETA e em DESENVOLVIMENTO. Para problemas ou sugestões, use o botão de Feedback.',
  
  // Progress Messages
  progressParsing: 'Analisando etiquetas...',
  progressConverting: 'Convertendo {{current}}/{{total}} etiquetas...',
  progressConvertingSimple: 'Convertendo etiquetas...',
  progressUpscaling: 'Melhorando {{current}}/{{total}} etiquetas...',
  progressUpscalingSimple: 'Melhorando qualidade...',
  progressOrganizing: 'Organizando PDF...',
  progressUploading: 'Finalizando...',
  progressFinalizing: 'Liberando memória...',
  progressComplete: 'Concluído!',
  etaSeconds: '~{{seconds}}s restantes',
  etaMinutes: '~{{minutes}}min {{seconds}}s restantes',
  etaFinalizing: 'Finalizando...',
  
  // Donation
  supportProject: 'Apoiar o Projeto',
  support: 'Apoiar',
  donationDescription: 'Sua contribuição ajuda a manter o ZPL Easy gratuito e em constante evolução. Escolha um valor para doar:',
  donationHelpMessage: 'Sua doação mantém o projeto gratuito e em evolução. Obrigado!',
  donateNow: 'Doar Agora',
  donateWithCard: 'Doar com Cartão',
  card: 'Cartão',
  scanPixQrCode: 'Escaneie o QR Code com o app do seu banco',
  likedIt: 'Gostou? Considere apoiar o projeto!',
  donationSuccessTitle: 'Obrigado pela Doação!',
  donationThankYouMessage: 'Sua generosidade nos ajuda a continuar melhorando o ZPL Easy.',
  donationImpactMessage: 'Seu apoio é fundamental para mantermos a ferramenta gratuita e adicionarmos novos recursos.',
  footerDescription: 'A melhor plataforma para conversão de ZPL para PDF. Simples, rápido e seguro.',
  supporter: 'apoiador',
  supporters: 'apoiadores',
  
  // Donation CTA in History
  donationCta: {
    title: 'Apoie o projeto!',
    subtitle: 'Contribua via PIX',
    message: 'Escaneie com a câmera do app do seu banco',
    otherMethods: 'Ou doe com Cartão de Crédito',
  },

  // History retention note
  historyRetentionNote: 'Registros e arquivos com mais de 60 dias são excluídos automaticamente.',

  // History Stats
  historyStats: {
    summary: 'Resumo',
    totalLabels: '{{count}} etiquetas',
    totalConversions: '{{count}} conversões',
  },

  // History Filters
  historyFilters: {
    search: 'Buscar...',
    allDates: 'Todas as datas',
    today: 'Hoje',
    last7Days: 'Últimos 7 dias',
    last30Days: 'Últimos 30 dias',
    allTypes: 'Todos os tipos',
    standard: 'Padrão',
    hd: 'Nitidez+',
  },

  // Bulk Actions
  bulkActions: {
    selected: '{{count}} selecionado(s)',
    downloadSelected: 'Baixar',
    deleteSelected: 'Excluir',
    clearSelection: 'Limpar seleção',
  },

  // Conversion Type
  conversionType: {
    standard: 'Padrão',
    hd: 'Nitidez+',
  },

  // History Status
  historyStatus: {
    ready: 'Pronto',
    unavailable: 'Indisponível',
  },

  // Processing time
  processingTimeLabel: '{{time}}s',
};

export default translations;

